export { DealsTourCard } from "./DealsTourCard";
export type { DealsTourCardDeparture, DealsTourCardProps } from "./types";
